import { TinyEmitter } from 'tiny-emitter';

interface Events
{
    $on(eventName: string, callback: (...args: any[]) => void): void;
    $once(eventName: string, callback: (...args: any[]) => void): void;
    $off(eventName: string, callback: (...args: any[]) => void): void;
    $emit(eventName: string, ...args: any[]): void;
}

export class EventsHelper implements Events
{
    private emitter: TinyEmitter;

    public constructor(emitter: any)
    {
        this.emitter = emitter;
    }

    public $on(eventName: string, callback: (...args: any[]) => void): void
    {
        this.emitter.on(eventName, callback);
    }

    public $once(eventName: string, callback: (...args: any[]) => void): void
    {
        this.emitter.once(eventName, callback);
    }

    public $off(eventName: string, callback: (...args: any[]) => void): void
    {
        this.emitter.off(eventName, callback);
    }

    public $emit(eventName: string, ...args: any[]): void
    {
        this.emitter.emit(eventName, ...args);
    }
}

export default defineNuxtPlugin({
    name: 'events',
    dependsOn: [],
    async setup(nuxtApp)
    {
        return {
            provide: {
                events: new EventsHelper(new TinyEmitter())
            }
        };
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        $events: Events;
    }
}
